import React from 'react';
import ArticleVideos from './ArticleVideos';
import { IArticleResponse } from './ICustomerService';

export interface FaqArticlesItemProps {
    article: IArticleResponse;
}

const FaqArticlesItem = ({ article }: FaqArticlesItemProps) => {
    return (
        <>
            <div dangerouslySetInnerHTML={{ __html: article?.Article.ShortenedContent }}></div>
            <ArticleVideos article={article} />
        </>
    );
};

export default FaqArticlesItem;
